module.exports = __webpack_public_path__ + "static/media/storas.b9a70bc4.jpg";